<template>
  <div>
    <div v-if="loading" class="text-xs-center my-5 pt-5">
      <v-progress-circular :size="50" color="black" indeterminate />
    </div>

    <div v-else>
      <v-layout row>
        <v-flex>
          <h1>{{ $t('ACCOUNT.DRAFT_ARTWORKS') }}</h1>
        </v-flex>
        <v-flex text-xs-right>
          <tk-btn dark small :to="{ name: 'profile.artworks.edit'}">
            <v-icon class="mr-2" left size="16">fas fa-plus</v-icon>
            {{ $t('ACCOUNT.NEW_ARTWORK')}}
          </tk-btn>
        </v-flex>
      </v-layout>

      <masonry :cols="{default: 3, 1200: 2, 960: 1}" :gutter="40">
        <tk-artwork v-for="artwork in artworks" :key="artwork.id" class="mb-4" :artwork="artwork">
          <template v-slot:action-btns>
            <v-divider />
            <v-card-actions class="pa-0">
              <tk-btn
                flat
                block
                :to="{ name: 'profile.artworks.edit', params: {artworkId: artwork.id}}"
                :disabled="artwork.cloning || artwork.unhiding"
              >
                <span>{{ $t('ACCOUNT.EDIT') }}</span>
              </tk-btn>

              <tk-btn
                block
                :disabled="artwork.cloning || artwork.unhiding"
                :loading="artwork.cloning"
                flat
                @click="clone($event, artwork)"
              >{{ $t('ACCOUNT.CLONE') }}</tk-btn>

              <tk-btn
                :disabled="artwork.cloning || artwork.unhiding || artwork.deleting"
                :loading="artwork.deleting"
                flat
                block
                @click="removeArtwork($event, artwork)"
              >{{ $t('COMMON.DELETE') }}</tk-btn>
            </v-card-actions>
          </template>
        </tk-artwork>
      </masonry>

      <div class="text-xs-right mt-4" v-if="artworks.length">
        <v-pagination
          @input="fetchData"
          :disabled="loading"
          :value="pagination.currentPage"
          :length="pagination.lastPage"
          :total-visible="7"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "@/services/RepositoryFactory";
import { ErrorHandler } from "@/utils/ErrorHandler";

const artworksRepo = RepositoryFactory.artworks();
const handler = new ErrorHandler();

export default {
  data() {
    return {
      showSortDialog: false,
      artworks: [],
      pagination: {},
      loading: true,
    };
  },

  created() {
    this.fetchData(1);
  },

  methods: {
    async fetchData(page) {
      this.loading = true;
      await handler.handle(async () => {
        const res = await artworksRepo.profileDraftArtworks(page);
        console.log(res);

        this.artworks = res.data;
        this.pagination = res.pagination;
      });
      this.loading = false;
    },

    async clone(e, artwork) {
      e.stopPropagation();
      artwork.cloning = true;
      await handler.handle(async () => {
        const res = await artworksRepo.cloneArtwork(artwork.id);
        console.log({ res });
        await this.$auth.refresh();

        this.$router.push({
          name: "profile.artworks.edit",
          params: { artworkId: res.id },
        });
      });
      artwork.cloning = false;
    },

    async removeArtwork(e, artwork) {
      e.stopPropagation();
      artwork.deleting = true;
      await handler.handle(async () => {
        await artworksRepo.removeArtwork(artwork.id);
        const pos = this.artworks.findIndex((art) => art.id === artwork.id);
        if (pos !== -1) this.artworks.splice(pos, 1);
        await this.$auth.refresh();
      });

      artwork.deleting = false;
    },
  },
};
</script>
